<!-- 分页组件 -->
<template>
  <div class="base-pagination">
    <el-pagination
      class="pagination"
      background
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="pageSizes"
      :layout="layout"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="changePage"
    />
    <p v-if="totalShow" class="pagination-total">共有{{ total }}条</p>
  </div>
</template>
<script>
export default {
  name: 'BasePagination',
  props: {
    total: {
      type: Number,
      required: true,
    },
    totalShow: {
      type: Boolean,
      default: true,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    layout: {
      type: String,
      default: 'sizes, prev, pager, next, jumper',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    changePage(val) {
      this.$emit('update:currentPage', val);
      this.$emit('changePage', val);
    },
    handleSizeChange(val) {
      this.$emit('update:pageSize', val);
      this.$emit('changeSize', val);
    },
  },
};
</script>
<style lang="scss" scoped>
.base-pagination {
  width: 100%;
  padding-top: 15px;
  display: flex;
  justify-content: flex-end;
  .el-pagination {
    padding: 0 10px;
    color: #666666;
    margin-top: 0px;
    .el-pager li {
      color: #666666;
    }
  }
  .pagination-total {
    margin-right: 8px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 32px;
  }

  .el-pager li.is-active {
    background: #316F7E;
    color: #FFFFFF;
  }

  .el-pager li:hover {
    color: #FFFFFF;
  }
}
</style>
